import { Builder } from "@builder.io/react";

import { BuilderTypography } from "./BuilderTypography";

export const registerBuilderTypography = () => {
  Builder.registerComponent(BuilderTypography, {
    name: "Typography",
    hideFromInsertMenu: false,
    noWrap: true,
    inputs: [
      {
        name: "textContent",
        // TODO: FD-256885 - Handle rich text better
        type: "richText",
        defaultValue: "Enter some text...",
        localized: true,
      },
      {
        name: "variant",
        type: "object",
        defaultValue: {
          mobileAndAbove: "paragraphSansRegular",
          tabletAndAbove: "paragraphSansRegular",
          desktopAndAbove: "paragraphSansRegular",
          xLargeAndAbove: "paragraphSansRegular",
          xxLargeDesktop: "paragraphSansRegular",
        },
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "displayXLSerifRegular",
              "displayLSerifRegular",
              "displayMSerifRegular",
              "displaySSerifRegular",
              "displaySSansSemiBold",
              "displaySSansRegular",
              "pageHeaderSerifRegular",
              "sectionHeaderSansMedium",
              "subheadingSansMedium",
              "subheadingSansRegular",
              "paragraphSansMedium",
              "paragraphSansRegular",
              "labelSansRegular",
              "labelSansMedium",
            ],
          },
        ],
      },
      {
        name: "color",
        type: "color",
        defaultValue: "var(--slate-color-text-primary, #333333)",
      },
      {
        name: "align",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: [
              "center",
              "end",
              "justify",
              "left",
              "right",
              "start",
              "unset",
            ],
          },
        ],
      },
      {
        name: "as",
        type: "string",
        enum: ["h1", "h2", "h3", "h4", "h5", "p", "span", "label"],
      },
      {
        name: "truncate",
        type: "boolean",
      },
      {
        name: "maxLines",
        type: "number",
      },
      {
        name: "strikethrough",
        type: "boolean",
      },
    ],
  });
};
